import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { Text } from '@famly/mf_data-display_text';
import { createStack, Stack } from '@famly/mf_layout_stack';
import { Spinner } from '@famly/mf_feedback_spinner';
export const PageBodyContainer = styled(createStack({
    flexDirection: 'column',
    pb: '162px', // value from designs
})) ``;
export const BottomBarContainer = ({ children }) => {
    return _jsx(StyledBottomBarContainer, { children: children });
};
export const StyledBottomBarContainer = styled(createStack({
    position: 'fixed',
    left: '0',
    right: '0',
    bottom: '0',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: '24px',
    gap: '16px',
    backgroundColor: 'n25',
})) `
    z-index: 100;
`;
const StyledButton = styled(createStack({
    alignItems: 'center',
    justifyContent: 'center',
    height: '64px',
    borderRadius: '16px',
    cursor: 'pointer',
    overflow: 'hidden',
    flex: 1,
    borderColor: 'n200',
    borderWidth: '1px',
    borderStyle: 'solid',
})) ``;
const StyledConfirmButton = styled(StyledButton).withConfig({
    shouldForwardProp: prop => prop !== 'isOnlyButton',
}) `
    border: none;
    color: ${props => (props.disabled ? props.theme.mf.colorPalette.n200 : props.theme.mf.colorPalette.n0)};
`;
const StyledLink = styled(Link) `
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const ConfirmButton = (props) => {
    const { text, type, onClick, isLoading, disabled, dataE2EId, isOnlyButton } = props;
    const handleOnClick = React.useCallback(() => {
        if (!disabled && onClick) {
            onClick();
        }
    }, [disabled, onClick]);
    const bgColour = React.useMemo(() => {
        if (disabled) {
            return 'n75';
        }
        if (type === 'signIn') {
            return 'g400';
        }
        return 'r400';
    }, [disabled, type]);
    return (_jsx(StyledConfirmButton, { onClick: handleOnClick, disabled: disabled, "data-e2e-id": dataE2EId, isOnlyButton: isOnlyButton, backgroundColor: bgColour, children: isLoading ? (_jsx(Stack, { justifyContent: "center", width: "100%", children: _jsx(Spinner, { size: 32, color: "n0", "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) })) : (_jsx(Text, { variant: "h5", textAlign: "center", color: disabled ? 'n300' : 'n0', children: text })) }));
};
const ButtonWithBackground = styled(StyledButton) `
    border: 1px solid ${props => props.theme.mf.colorPalette.n200};
`;
export const ActionButton = (props) => {
    const { text, link, compact } = props;
    return (_jsx(ButtonWithBackground, { backgroundColor: "n0", children: _jsx(StyledLink, { to: link, children: _jsx(Text, { variant: compact ? 'body' : 'h5', color: "n400", textAlign: "center", children: text }) }) }));
};
export const ActionOnClickButton = ({ text, onClick, backgroundColor = 'n0', color = 'n400', borderColor = 'n200', compact, dataE2EId, }) => {
    return (_jsx(StyledButton, { backgroundColor: backgroundColor, borderColor: borderColor, onClick: onClick, "data-e2e-id": dataE2EId, children: _jsx(Text, { variant: compact ? 'body' : 'h5', color: color, textAlign: "center", children: text }) }));
};
